module.exports = __webpack_public_path__ + "img/wz-8-5-6.c63ee81c.jpg";